// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"63":"98f168bb","523":"b42f5494","559":"98f168bb","575":"98f168bb","847":"98f168bb","949":"98f168bb","972":"98f168bb"}[chunkId] + ".chunk.css";
};